<script setup lang="ts">
  definePageMeta({
    layout: 'chat'
  });

  useHead({
    title: ''
  });

  const localePath = useLocalePath();

  const chatStore = useChatStore();
  const { isAiMode, isChatTermsAccepted, isChatLeaving, isChatLeaveGranted, isCompanyUrlModalOpen } = storeToRefs(chatStore);

  const onChatBack = () => {
    isChatLeaveGranted.value = false;
    isChatLeaving.value = false;
    isAiMode.value = true;
  };

  const onChatLeave = async () => {
    isChatLeaveGranted.value = true;
    isChatLeaving.value = true;
    await navigateTo(localePath('/'));
    isAiMode.value = false;
  };

  onMounted(() => {
    isAiMode.value = true;
    isChatLeaving.value = false;
  });

  watch(isChatTermsAccepted, () => {
    if (isChatTermsAccepted.value) {
      setTimeout(() => {
        isChatLeaving.value = true;
      }, 4000 * 60);
    }
  });

  onBeforeRouteLeave(() => {
    if (!isChatLeaveGranted.value) {
      isChatLeaving.value = true;
      return false;
    }

    chatStore.resetChat();
  });
</script>

<template>
  <main>
    <ChatBg />
    <ChatSection />
    <transition
      name="fade"
      mode="out-in">
      <ChatTermsModal v-if="!isChatTermsAccepted" />
    </transition>
    <transition
      name="fade"
      mode="out-in">
      <ChatChameleonModal v-if="isCompanyUrlModalOpen" />
    </transition>
    <transition
      name="fade"
      mode="out-in">
      <ChatLeaveModal
        v-if="isChatLeaving"
        @back="onChatBack"
        @leave="onChatLeave" />
    </transition>
  </main>
</template>
